import { readSession, writeSession } from '../../core/storage'

/**
 * Het ondertekende token uit de Mollie-terugkeerlink (`/bestelling/:id?t=…`). Zolang het in de
 * adresbalk staat, komt het in de geschiedenis, in schermdelen en in een gedeelde link terecht.
 * Daarom: één keer lezen, in sessionStorage voor dit tabblad bewaren (zodat verversen blijft werken),
 * en meteen uit de adresbalk halen, zoals de inlog-, herstel- en bevestigingslinks.
 */

const KEY = 'bb-order-token'

type Stored = { orderId: string; token: string }

/** Het adres zonder `name`, als relatief pad met query en hash; `null` als het er niet in stond. */
export function withoutParam(href: string, name: string): string | null {
  const url = new URL(href)
  if (!url.searchParams.has(name)) return null
  url.searchParams.delete(name)
  return `${url.pathname}${url.search}${url.hash}`
}

/** Het bewaarde token hoort alleen bij dezelfde bestelling. */
export function storedTokenFor(raw: string | null, orderId: string): string {
  if (!raw) return ''
  try {
    const s = JSON.parse(raw) as Partial<Stored>
    return s.orderId === orderId && typeof s.token === 'string' ? s.token : ''
  } catch {
    return ''
  }
}

export function takeOrderToken(orderId: string): string {
  if (typeof window === 'undefined') return ''
  const fromUrl = new URL(window.location.href).searchParams.get('t')?.trim() ?? ''
  if (fromUrl) {
    writeSession(KEY, JSON.stringify({ orderId, token: fromUrl } satisfies Stored))
    const clean = withoutParam(window.location.href, 't')
    // `history.state` meegeven: React Router bewaart daar zijn sleutel.
    if (clean) window.history.replaceState(window.history.state, '', clean)
    return fromUrl
  }
  return storedTokenFor(readSession(KEY), orderId)
}

/** Bij uitloggen op een gedeeld apparaat. */
export const forgetOrderToken = () => writeSession(KEY, '')
